import { Layout, ErrorDisplay } from '../components/Layout';

const NotFound = () => {
  return (
    <Layout title="Page Not Found">
      <ErrorDisplay
        message="The requested page could not be found. Please check the URL and try again."
      />
    </Layout>
  );
};

export default NotFound;
